<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-field label="リクエストエリア" expanded>
          <b-input v-model="item.yardArea" :disabled="checkEditPrice"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="リクエストヤード" expanded>
          <b-input v-model="item.yardName" :disabled="checkEditPrice"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="ハンドリング会社">
          <b-input v-model="item.handlingCompany" :disabled="checkEditPrice"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="向け地" expanded>
          <b-input v-model="item.exportCountry" :disabled="checkEditPrice"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="揚げ地" expanded>
          <b-input v-model="item.exportDischargePort" :disabled="checkEditPrice"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="船積方法">
          <b-select expanded v-model="item.exportType" :disabled="checkEditPrice">
            <option value=""></option>
            <option value="RORO">RORO</option>
            <option value="CONTAINER">CONTAINER</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="field">
      <b-field class="has-text-left" expanded>
        <b-checkbox v-model="item.exportHasBodyWorkRequest" :disabled="checkEditPrice"
          >野田ヤード作業依頼</b-checkbox
        >
      </b-field>
      <b-field class="has-text-left" expanded>
        <b-checkbox v-model="item.exportHasInspectionRequest" :disabled="checkEditPrice"
          >輸出向け検査依頼</b-checkbox
        >
      </b-field>
    </div>
  </div>
</template>
<style scoped>
::v-deep .column {
  padding: 5px;
  padding-bottom: 10px;
}
</style>
<script>
export default {
  props: ['item', 'yards','checkEditPrice'],
};
</script>
